import { ProgramDocumentRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateProgramDocument: (
  fetchContext: FetchContext,
  programDocumentId: number,
  programDocument: ProgramDocumentRequest,
  accessToken?: string,
) => Promise<number> = async (fetchContext, programDocumentId, programDocument, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/program-documents/${programDocumentId}`,
  {
    method: 'PUT',
    body: JSON.stringify(programDocument),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'update program document', !response.ok, [], true));
